"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomerOrderToReview = void 0;
const react_1 = require("react");
const customer_1 = require("../../services/customer");
const api_1 = require("../../utils/helpers/api");
const { initialState, reducer, actions } = (0, api_1.createApiReducer)({
    orderToReview: undefined,
});
function useCustomerOrderToReview(customerId, enabled = true) {
    const [state, dispatch] = (0, react_1.useReducer)(reducer, initialState);
    (0, react_1.useEffect)(() => {
        const fetchOrderToReview = () => __awaiter(this, void 0, void 0, function* () {
            if (!enabled)
                return;
            dispatch(actions.callApi());
            try {
                const data = yield (0, customer_1.getCustomerOrderToReview)(customerId);
                dispatch(actions.resolve({ orderToReview: data }));
            }
            catch (err) {
                dispatch(actions.reject(err));
            }
        });
        fetchOrderToReview();
    }, [customerId, enabled]);
    return (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, state), { idle: !state.loading && !state.error && !state.resolved })), [state]);
}
exports.useCustomerOrderToReview = useCustomerOrderToReview;
